/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OverrideAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function OverrideAction({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/OverrideAction",
  onSubmit,
  isSubmitting
  
}) {
let rulesetSubmitData = fromData.useDataSubmit({ viewPath,
context: 'ruleset',
})
let rulesetIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'ruleset',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 data="ruleset"
 onClick={rulesetSubmitData}
 disabled={rulesetIsSubmittingData}
 type="primary"
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Override"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}